import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';

import { MaintenanceService } from '../../services/maintenance/maintenance.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  constructor(private maintenanceService: MaintenanceService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const isMaintenanceMode = this.maintenanceService.currentIsMaintenanceMode;
    if (isMaintenanceMode) {
      // Allow access to maintenance display page itself (/maintenance)
      const isMaintenanceDisplayPage =
        route.routeConfig?.path === 'maintenance' ||
        state.url === '/maintenance' ||
        state.url.startsWith('/maintenance?');

      if (isMaintenanceDisplayPage) {
        return true;
      }

      // Allow access to maintenance management page (/quest/global/maintenance) so Super Admins can disable it
      const isMaintenanceManagementPage =
        state.url.includes('/quest/global/maintenance') ||
        state.url.includes('/global/maintenance');

      if (isMaintenanceManagementPage) {
        return true;
      }

      // Redirect all other routes to maintenance display page
      return this.router.parseUrl('/maintenance');
    }

    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }
}
